import { LegalEntityType } from 'shared/data/walletsKyc/v1';

import { sortOtherLast } from '../../../../resources/helpers';
import { legalEntityTypeMessages } from './StepForm.messages';

const legalEntityTypesToMessages = {
    [LegalEntityType.company_with_nominee_shareholders_or_shares_in_bearer_form]:
        legalEntityTypeMessages.companyWithNomineeShareholdersOrSharesInBearerForm,
    [LegalEntityType.limited_liability_company]: legalEntityTypeMessages.limitedLiabilityCompany,
    [LegalEntityType.limited_liability_partnership]: legalEntityTypeMessages.limitedLiabilityPartnership,
    [LegalEntityType.other]: legalEntityTypeMessages.other,
    [LegalEntityType.public_limited_company]: legalEntityTypeMessages.publicLimitedCompany,
    [LegalEntityType.registered_charity]: legalEntityTypeMessages.registeredCharity,
    [LegalEntityType.scottish_limited_partnership]: legalEntityTypeMessages.scottishLimitedPartnership,
    [LegalEntityType.trust]: legalEntityTypeMessages.trust,
    [LegalEntityType.unincorporated_partnership]: legalEntityTypeMessages.unincorporatedPartnership,
    [LegalEntityType.unregistered_charity]: legalEntityTypeMessages.unregisteredCharity,
};

export const legalEntityTypes = sortOtherLast(
    LegalEntityType,
    Object.keys(LegalEntityType).map((legalEntityType: LegalEntityType) => ({
        id: legalEntityType,
        name: legalEntityTypesToMessages[legalEntityType],
    }))
);
